import data from '../assets/data.json';
import $ from 'jquery';

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getFilterRange(type) {
  var start = null;
  if (type == 'today') {
    start = new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000);
  } else if (type == 'this-week') {
    start = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000);
  } else if (type == 'this-month') {
    start = new Date(new Date().getTime() - 31 * 24 * 60 * 60 * 1000);
  }
  return [start, new Date()];
}
// For calucalte time-ago
import { format, register } from 'timeago.js';

function localeFunc(number, index) {
  return [
    ['剛剛', '片刻後'],
    ['%s 秒前', '%s 秒後'],
    ['1 分鐘前', '1 分鐘後'],
    ['%s 分鐘前', '%s 分鐘後'],
    ['1 小時前', '1 小時後'],
    ['%s 小時前', '%s 小時後'],
    ['1 天前', '1 天後'],
    ['%s 天前', '%s 天後'],
    ['1 週前', '1 週後'],
    ['%s 週前', '%s 週後'],
    ['1 個月前', '1 個月後'],
    ['%s 個月前', '%s 個月後'],
    ['1 年前', '1 年後'],
    ['%s 年前', '%s 年後']
  ][index];
}

export function getTime(createdAt) {
  register('zh_TW', localeFunc);
  return format(createdAt, 'zh_TW');
}

export function getCategoryNameById(categoryId, lang) {
  var category = data[lang].sidemenu.pages.categories;
  for (var i = 0; i < category.length; i++) {
    if (category[i].id == categoryId) {
      if(categoryId==="2" || categoryId==="3"){
        return category[i].name;
      }
    }
  }
  return '其他'
}

export function getTagClass(tagId, className, txt = false) {
  if (tagId == 1) {
    if (txt) return className + '--government';
    return className + '--governmentNoTxt';
  } else if (tagId == 2) return className + '--true';
  else if (tagId == 3) return className + '--true';
  else if (tagId == 4) return className + '--false';
  else if (tagId == 5) return className + '--clarified';
  else if (tagId == 6) return className + '--lack';
}

export function getParams(params, data) {
  for (var sortKey in params['sort']) {
    if (params['sort'][sortKey]['default'] != true)
      delete params['sort'][sortKey];
  }
  var sortData = JSON.parse(JSON.stringify(data));
  var dir;
  if (sortData.direction < 0) dir = 'desc';
  else if (sortData.direction > 0) dir = 'asc';
  else if (sortData.direction == 0) {
    delete params['sort'][sortData.type];
    return params;
  } else return params;

  if (sortData.type == 'govPartner') {
    sortData.type = 'govOption';
  }
  if (
    params['sort'][sortData.type] &&
    params['sort'][sortData.type].default == true
  )
    params['sort'][sortData.type].dir = dir;
  else {
    params['sort'][sortData.type] = {
      dir: dir,
      default: false
    };
  }
  return params;
}

export function disableSort(sortType) {
  if (sortType == 'comments.size') sortType = 'comments-size';
  $('.tableTop-' + sortType).removeClass('color--greyCharcoal90');
  $('.tableTop-' + sortType).addClass('color--greyCharcoal30');
  $('.icon-' + sortType).removeClass('icon-arrow-down');
  $('.icon-' + sortType).removeClass('icon-arrow-up');
  $('.icon-' + sortType).addClass('icon-arrow');
}

export function changeStyle(sortData) {
  let sortType = sortData.type;
  if (sortType) sortType = sortType.replace('article.', '');
  if (sortData.type == 'comments.size') sortType = 'comments-size';
  $('.tableTop-' + sortType).removeClass('color--greyCharcoal30');
  $('.tableTop-' + sortType).addClass('color--greyCharcoal90');
  $('.icon-' + sortType).removeClass('icon-arrow');
  if (sortData.direction > 0) {
    $('.icon-' + sortType).removeClass('icon-arrow-down');
    $('.icon-' + sortType).addClass('icon-arrow-up');
  } else if (sortData.direction < 0) {
    $('.icon-' + sortType).removeClass('icon-arrow-up');
    $('.icon-' + sortType).addClass('icon-arrow-down');
  } else {
    disableSort(sortType);
  }
}

export function getDate(dateStr) {
  if (dateStr == null)
    return {
      year: '',
      month: '',
      date: ''
    };
  let newDate = new Date(dateStr);
  let month = newDate.getMonth() + 1;
  return {
    year: newDate.getFullYear(),
    month: (month < 10 ? '0' : '') + month,
    date: (newDate.getDate() < 10 ? '0' : '') + newDate.getDate(),
    hour: (newDate.getHours() < 10 ? '0' : '') + newDate.getHours(),
    minute: (newDate.getMinutes() < 10 ? '0' : '') + newDate.getMinutes()
  };
}
export function deviceType() {
  if (window.innerWidth > 1920) return 'desktop-hd';
  else if (window.innerWidth > 1360) return 'desktop';
  else if (window.innerWidth > 768) return 'tablet';
  else return 'mobile';
}

export function getDateString(date) {
  return date.toLocaleDateString();
}

export function newDateObject(date) {
  if (date instanceof Date) {
    return new Date(date);
  }
  const s = date.split('-').join('/');
  return new Date(s);
}

export function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function lockBody() {
  document.getElementsByTagName('BODY')[0].classList.add('bodyLock');
}

export function unlockBody() {
  document.getElementsByTagName('BODY')[0].classList.remove('bodyLock');
}

export function isMobileOrTablet() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'none';
}

export function isIOS() {
  var iDevices = ['iPad', 'iPhone', 'iPod'];
  // eslint-disable-next-line
  if (!!navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }
  return false;
}

export function getNumberString(num) {
  if (!num) return '0';
  var si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' }
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var digits = 0;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      if (num < si[i].value * 10) digits = 1;
      break;
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol;
}
export function getRouteByParam(params, route) {
  if (params) {
    route += '?';
    for (var key in params) {
      if (key == 'sort') {
        var lastSort = {};
        for (let sortKey in params[key]) {
          if (params[key][sortKey]['default'] == true)
            lastSort[sortKey] = params[key][sortKey];
          else
            route +=
              key + '=' + sortKey + ',' + params[key][sortKey]['dir'] + '&';
        }
        for (let sortKey in lastSort)
          route +=
            key + '=' + sortKey + ',' + params[key][sortKey]['dir'] + '&';
      } else if (key == 'govOptionId' && params[key] == 0) continue;
      else if (params[key] != null && params[key] != '') {
        route += key + '=' + params[key] + '&';
      }
    }
  }
  return route;
}

export function initCurrentSortByQueryStr(queryParams, type) {
  if (queryParams == null) return null;
  let sortData = JSON.parse(queryParams).sort;
  let currentSort = null;
  var cnt = 0;
  for (var key in sortData) {
    if (cnt == 0 || sortData[key].default != true) {
      const sortType =
        type === 'partnerFollowingArticles'
          ? key.replace(/^article\./, '')
          : key;
      currentSort = {
        type: sortType,
        direction: sortData[key].dir === 'asc' ? 1 : -1
      };
      changeStyle(currentSort);
    }
    cnt++;
  }
  return currentSort;
}

export function initLocalParamByQueryStr(query, params) {
  if (query.params == null) return params;
  let queryParams = JSON.parse(query.params);
  for (var key in queryParams) {
    params[key] = queryParams[key];
  }
  return params;
}

export function checkPopupAlert(condition, alert) {
  let alertText = '--alert';
  if (condition) {
    for (let key in alert) {
      if (key == 'alertText') alert[key] = true;
      else if (!alert[key].includes(alertText)) alert[key] += alertText;
    }
  } else {
    for (let key in alert) {
      if (key == 'alertText') alert[key] = false;
      else alert[key] = alert[key].replace(alertText, '');
    }
  }
  return alert;
}

export function getImgURL(img) {
  return (
    process.env.VUE_APP_CDN_URL + process.env.VUE_APP_STATIC_IMG_ROUTE + img
  );
}
export function getCategoryImgURL(img) {
  return (
    process.env.VUE_APP_CDN_URL +
    process.env.VUE_APP_STATIC_CATEGORY_ROUTE +
    img
  );
}
